import React from 'react';
import { Modal, ModalFooter } from 'reactstrap';
import ModalBody from 'reactstrap/lib/ModalBody';
import { IBuyboxProps } from '../../definition-extensions/buybox.ext.props.autogenerated';
import { IBuyboxDataExtended } from '../../views/buybox.data';
import { IBuyboxViewProps } from '@msdyn365-commerce-modules/buybox';

const ConfirmationModal = ({
    isModalOpen,
    setIsConfirmationModalOpen,
    toggleSDABModal,
    restProps
}: {
    isModalOpen: boolean;
    setIsConfirmationModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    toggleSDABModal: React.Dispatch<React.SetStateAction<boolean>>;
    restProps: IBuyboxViewProps & IBuyboxProps<IBuyboxDataExtended>;
}) => {
    const {
        resources: { warningLabel, closeModalLabel, confirmLabel, cancelLabel, confirmationText }
    } = restProps;
    const closeConfirmationModal = () => {
        setIsConfirmationModalOpen(false);
    };
    const closeAllModal = () => {
        setIsConfirmationModalOpen(false);
        toggleSDABModal(false);
    };
    return (
        <Modal
            role='document'
            aria-labelledby='productSearchTitle'
            className='cui modal-sm'
            keyboard={true}
            isOpen={isModalOpen}
            toggle={closeConfirmationModal}
        >
            <div className='modal-header'>
                <h2 id='productSearchTitle' tabIndex={0} className='modal-title'>
                    {warningLabel}
                </h2>
                <button className='btn-modal-close cui btn-md primary-text' onClick={closeConfirmationModal}>
                    {closeModalLabel}
                </button>
            </div>
            <ModalBody>
                <div className='modal-content'>{confirmationText}</div>
            </ModalBody>
            <ModalFooter>
                <div className='btn-box elecSearchBtn two-btn'>
                    <button
                        type='button'
                        // disabled={!verifiedProducts.some(prod => prod.documentList.some(doc => doc.isChecked === true))}
                        className='cui btn-md primary'
                        onClick={() => closeAllModal()}
                    >
                        {confirmLabel}
                    </button>
                    <button
                        type='button'
                        // disabled={!verifiedProducts.some(prod => prod.documentList.some(doc => doc.isChecked === true))}
                        className='cui btn-sm utility-btn-solid'
                        onClick={() => closeConfirmationModal()}
                    >
                        {cancelLabel}
                    </button>
                </div>
            </ModalFooter>
        </Modal>
    );
};

export default ConfirmationModal;
